/*
  Gift Set cart guard.

  Gift line items are priced at or near zero, so they must never outlive the
  scooter they were attached to. This drops any gift whose parent product has
  left the cart.

  That is the only rule here on purpose. Gifts are deliberately not deduped
  (the picker is multi-select) and their quantity is never synced to the
  parent's (gifts are per order, not per scooter) — both behaviours belong to
  the retired `_is_gift` system and would be wrong for this module.

  Matching is on `_gift_for_product`, so changing the scooter's colour keeps
  the gifts while removing the scooter clears them.

  Nothing is written when the cart already satisfies the rule, so the ordinary
  add-to-cart and checkout paths are untouched.
*/
(function () {
  if (window.__giftSetCartGuardLoaded) return;
  window.__giftSetCartGuardLoaded = true;

  var DEBOUNCE_MS = 250;
  var running = false;
  var dirty = false;
  var debounceTimer = null;

  function parentProductOf(item) {
    var props = item && item.properties;
    if (!props) return '';
    return String(props._gift_for_product || '');
  }

  function isGiftItem(item) {
    return parentProductOf(item) !== '';
  }

  // Keys of gift lines whose parent product is gone from the cart.
  function findOrphans(cart) {
    var presentProducts = Object.create(null);
    var i;

    for (i = 0; i < cart.items.length; i++) {
      if (isGiftItem(cart.items[i])) continue;
      presentProducts[String(cart.items[i].product_id)] = true;
    }

    var orphans = [];
    for (i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (!isGiftItem(item)) continue;
      if (!presentProducts[parentProductOf(item)]) orphans.push(item.key);
    }
    return orphans;
  }

  // The sections this theme re-renders for the cart: the drawer, and the cart page
  // when the shopper is on it (its id is assigned by the template).
  function collectSectionIds() {
    var ids = ['cart-drawer'];
    var page = document.querySelector('[data-cart-page]');
    if (page && page.dataset.sectionId) ids.push(page.dataset.sectionId);
    return ids;
  }

  function removeLine(key, sectionIds) {
    var body = { id: key, quantity: 0 };
    if (sectionIds) {
      body.sections = sectionIds;
      body.sections_url = window.location.pathname;
    }
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .catch(function (e) {
        if (window.console) console.warn('[gift-set-guard] remove failed', e);
        return null;
      });
  }

  // Swap a freshly rendered region into place — the same move the theme's own cart
  // code makes.
  function applySection(html, selector) {
    if (!html) return;
    var incoming = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    var current = document.querySelector(selector);
    if (incoming && current) current.replaceWith(incoming);
  }

  // Apply the refreshed drawer / cart page, then reconcile the bubble count.
  function renderFromResponse(state) {
    if (!state || !state.sections) return;

    applySection(state.sections['cart-drawer'], '[data-cart-content]');
    var page = document.querySelector('[data-cart-page]');
    if (page && page.dataset.sectionId) {
      applySection(state.sections[page.dataset.sectionId], '[data-cart-page]');
    }

    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll('[data-cart-count]').forEach(function (node) {
          node.textContent = cart.item_count;
          node.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  function sweep() {
    if (running) {
      dirty = true;
      return;
    }
    running = true;
    dirty = false;

    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return null;

        var orphans = findOrphans(cart);
        if (orphans.length === 0) return null;

        var sectionIds = collectSectionIds();
        var last = null;
        var chain = Promise.resolve();

        orphans.forEach(function (key, idx) {
          var isLast = idx === orphans.length - 1;
          chain = chain.then(function () {
            return removeLine(key, isLast ? sectionIds : null).then(function (resp) {
              if (isLast) last = resp;
            });
          });
        });

        return chain.then(function () {
          return last;
        });
      })
      .then(renderFromResponse)
      .catch(function (e) {
        if (window.console) console.warn('[gift-set-guard] aborted', e);
      })
      .then(function () {
        running = false;
        if (dirty) {
          dirty = false;
          schedule();
        }
      });
  }

  function schedule() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(sweep, DEBOUNCE_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sweep);
  } else {
    sweep();
  }

  // The theme fires this after any cart change (add, quantity edit, remove).
  document.addEventListener('cart:updated', schedule);
})();
